import React, { useRef, useEffect, useState } from 'react'
import { Animated, View, Text, StyleSheet } from 'react-native'

export const ToolTipView = ({ children, tooltip = null, reset = false }) => {
    const [showTooltip, setShowTooltip] = useState(true)
    const fade = useRef(new Animated.Value(0)).current

    useEffect(() => {
        if (!tooltip) return
        setShowTooltip(true)
        fade.setValue(0)

        Animated.timing(fade, {
            toValue: 1,
            duration: 300,
            useNativeDriver: true,
        }).start()

        const timer = setTimeout(() => {
            Animated.timing(fade, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start(() => setShowTooltip(false))
        }, 2000)

        return () => clearTimeout(timer)
    }, [reset, tooltip])

    if (!showTooltip || !tooltip) return <>{children}</>

    return (
        <View style={styles.anchorContainer}>
            <Animated.View style={[styles.tooltipWrapper, { opacity: fade }]}>
                {/* Flecha centrada verticalmente */}
                <View style={styles.arrow} />

                {/* Burbuja */}
                <View style={styles.bubble}>
                    <Text style={styles.text} numberOfLines={1}>
                        {tooltip}
                    </Text>
                </View>
            </Animated.View>

            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    anchorContainer: {
        position: 'relative',
    },

    tooltipWrapper: {
        position: 'absolute',
        left: '-250%', // mueve todo el tooltip a la izquierda del children
        top: '-5%',
        transform: [{ translateY: 0 }], // verticalmente centrado respecto al children
        zIndex: 999,
    },

    bubble: {
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        paddingVertical: 8,
        paddingHorizontal: 8,
        borderRadius: 8,
        minWidth: 100,
        maxWidth: 200,
    },

    text: {
        color: 'white',
        fontSize: 12,
        fontWeight: '400',
        textAlign: 'center',
    },

    arrow: {
        position: 'absolute',
        right: -8, // pega la flecha a la burbuja
        top: '50%',
        transform: [{ translateY: -3 }, { rotate: '-90deg' }],
        width: 0,
        height: 0,
        borderLeftWidth: 6,
        borderRightWidth: 6,
        borderTopWidth: 6,
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent',
        borderTopColor: 'rgba(0, 0, 0, 0.9)',
    },
})
